import { PAGES, PAGE_IDS, normalisePageId } from 'js/constants/Pages';
import { createSelector } from '@reduxjs/toolkit';

export const getStartFrontend = (state) => {
  return state.app.startFrontend;
};

const pageData = (state) => state.app.pagesData;
const selectPageDataId = (state, id) => id;

const selectPageDataById = createSelector([pageData, selectPageDataId], (data, id) => data[id]);

export const getCurrentPageData = (state, id) => {
  return selectPageDataById(state, normalisePageId(id)) || {};
};

export const getSiteMetaData = (state, id) => {
  if (state.app.meta.byID) {
    return state.app.meta.byID[id] || state.app.meta.byID[PAGE_IDS.home];
  }
  return {};
};

export const getSocialLinks = (state) => {
  return state.app.social;
};

export const getPreviewMode = (state) => {
  return state.app.previewMode;
};
